import PropTypes from "prop-types";
import React from "react";
import {
  Button,
  ButtonToolbar,
  Col,
  Form,
  FormControl,
  FormLabel,
  Row,
} from "react-bootstrap";
import { defineMessages, FormattedMessage, useIntl } from "react-intl";

import genericTranslations from "../../../../utils/genericTranslations.js";

const messages = defineMessages({
  code: {
    id: "modules.Malfunctions.components.CategoriesList.code",
    description: "Code",
    defaultMessage: "Code",
  },
  description: {
    id: "modules.Malfunctions.components.CategoriesList.description",
    description: "Description",
    defaultMessage: "Description",
  },
  type: {
    id: "modules.Malfunctions.components.CategoryForm.type",
    description: "Content item type label.",
    defaultMessage: "Vehicle type",
  },
  typeAll: {
    id: "modules.Malfunctions.components.CategoryForm.typeAll",
    description: "Category type label.",
    defaultMessage: "All",
  },
  typeBus: {
    id: "modules.Malfunctions.components.CategoryForm.typeBus",
    description: "Category type bus label.",
    defaultMessage: "Bus",
  },
  typeTrain: {
    id: "modules.Malfunctions.components.CategoryForm.typeTrain",
    description: "Category type train label.",
    defaultMessage: "Train",
  },
});

const CategoryForm = ({
  handleChange,
  handleSubmit,
  errors,
  isSubmitting,
  onClickDelete,
  values,
  setFieldValue,
}) => {
  const intl = useIntl();

  return (
    <Form onSubmit={handleSubmit}>
      <Row>
        <Col xs={12} md={8} lg={8}>
          <Form.Group controlId="value" className="mb-3">
            <FormLabel>
              <FormattedMessage {...messages.code} />
            </FormLabel>
            <FormControl
              type="text"
              autoComplete="off"
              value={values.value || ""}
              onChange={handleChange}
              isInvalid={!values.value}
            />
            <Form.Control.Feedback type="invalid">
              {errors.value}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="label" className="mb-3">
            <FormLabel>
              <FormattedMessage {...messages.description} />
            </FormLabel>
            <FormControl
              type="text"
              autoComplete="off"
              value={values.label || ""}
              onChange={handleChange}
              isInvalid={!values.label}
            />
            <Form.Control.Feedback type="invalid">
              {errors.label}
            </Form.Control.Feedback>
          </Form.Group>

          <Form.Group controlId="type" className="mb-3">
            <FormLabel>
              <FormattedMessage {...messages.type} />
            </FormLabel>
            <Form.Select
              value={values.vehicleType ? values.vehicleType.toUpperCase() : ""}
              onChange={(e) => setFieldValue("vehicleType", e.target.value)}
            >
              <option value="">{intl.formatMessage(messages.type)}</option>
              <option value="ALL">
                {intl.formatMessage(messages.typeAll)}
              </option>
              <option value="BUS">
                {intl.formatMessage(messages.typeBus)}
              </option>
              <option value="TRAIN">
                {intl.formatMessage(messages.typeTrain)}
              </option>
            </Form.Select>
            {errors.vehicleType && (
              <Form.Text muted>{errors.vehicleType}</Form.Text>
            )}
          </Form.Group>

          <hr />

          <Form.Group controlId="formActions">
            <ButtonToolbar>
              {values.id && (
                <Button
                  variant="danger"
                  className="me-2"
                  onClick={onClickDelete}
                >
                  <FormattedMessage {...genericTranslations.delete} />
                </Button>
              )}
              <Button
                type="submit"
                variant="light"
                disabled={isSubmitting || Object.keys(errors).length > 0}
              >
                <FormattedMessage {...genericTranslations.save} />
              </Button>
            </ButtonToolbar>
          </Form.Group>
        </Col>
      </Row>
    </Form>
  );
};

CategoryForm.propTypes = {
  handleChange: PropTypes.func.isRequired,
  handleSubmit: PropTypes.func.isRequired,
  isSubmitting: PropTypes.bool.isRequired,
  onClickDelete: PropTypes.func.isRequired,
  setFieldValue: PropTypes.func.isRequired,
  errors: PropTypes.object,
  values: PropTypes.object.isRequired,
};

export default CategoryForm;
